import React from "react";
import TextLabel from "../../Controls/TextLabel.mjs";
import "./LoadingPanel.css";
import AppFullLogo from "../../media/images/AppFullLogo.mjs";
import AppIcon from "../../media/images/AppIcon.mjs";
import HermesBayLogo from "../../media/images/HermesBayLogo.mjs";

const G = window.glob;

const LoadingPanel = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = { info: G.getStatus('AppInfo') };
		this.uid = G.generateUid('LoadingPanel');
	}

	render() {
		return (
			<div className={"LoadingPanel"}>
				<div className={"image"}>
					<div className={"logos"}>
						<div>
							<HermesBayLogo/>
						</div>
						<div>
							<AppFullLogo/>
						</div>
					</div>
					<div className={"icon"}>
						<AppIcon/>
					</div>
				</div>
				<div className={"comment"}>
					{this.props.message ?? <TextLabel value={"LoadInProgress"}/>}
				</div>
			</div>
		);
	}
}

export default LoadingPanel;
